import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ItemService } from './../services/item.service';
import { Spot } from '../models/Item';
import { Chart } from 'chart.js';


@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {

  constructor(public itemService: ItemService, public router: Router) { }

  


  chart = [];
  
  // public data: any[];
  // dateSelected: any;
  public daterange: any = {};
  public advertiser: any;
  public options: any = {
    locale: { format: 'MM/DD/YYYY' },
    
    alwaysShowCalendars: false,
    startDate: this.itemService.sd,
    endDate: this.itemService.ed,
    minDate: '01/01/2017',
    opens: 'left',
    showWeekNumbers: true,
    ranges: {
      // 'Yesterday': [
      //     '2018-02-26T07:00:33.456Z',
      //     '2018-02-26T07:00:33.456Z'
      // ],
      'Last 7 Days': [
        '01/01/2017',
        '31/03/2018',
      ],
      'Last 30 Days': [
        '03/02/2018',
        '03/31/2018'
      ],
      'This Month': [
        '03/01/2018',
        '03/31/2018'
      ],
      'Last Month': [
        '02/01/2018',
        '02/28/2018'
      ]
    },
  };


  

  public selectedDate(value: any, datepicker?: any) {

    this.itemService.showSpinner = true;
    
    datepicker.start = value.start;
    datepicker.end = value.end;

    // or manupulat your own internal property
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;

    let start;
    let end;
    start = new Date(this.daterange.start);
    end = new Date(this.daterange.end);

    // start Date Function
    const sd_date = ('0' + start.getDate()).slice(-2);
    const sd_Month = ('0' + (start.getMonth() + 1)).slice(-2);
    const sd_year = start.getFullYear();

    const startDate = ((sd_Month) + '-' + sd_date + '-' + sd_year);
    this.itemService.startDate = startDate;
    // console.log(this.itemService.startDate);

    // end Date Function
    const ed_date = ('0' + end.getDate()).slice(-2);
    const ed_Month = ('0' + (end.getMonth() + 1)).slice(-2);
    const ed_year = end.getFullYear();

    const endDate = ((ed_Month) + '-' + ed_date + '-' + ed_year);
    this.itemService.endDate = endDate;
    // console.log(this.itemService.endDate);

    // dateChanged Function

    this.itemService.startDateTemp = new Date(startDate)
    this.itemService.endDateTemp = new Date(endDate)
    this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;


   
    let categorySelected = this.itemService.selected_cat ? this.itemService.selected_cat : 'Not Selected';
    let parameters:any = { 
      section_name: 'Advertisers',
      page_name: 'Categories',
      category:categorySelected,
      startDate: this.itemService.startDate,
      endDate: this.itemService.endDate,
      days: this.itemService.days,
    }
    this.itemService.logEvent('onDateChange', parameters);

    this.itemService.selected_cat;
    this.itemService.dateChangeDetector();
  }


  onChange(value) {

    
    this.itemService.startDateTemp = new Date(this.itemService.sd)
    this.itemService.endDateTemp = new Date(this.itemService.ed)
    this.itemService.days =  Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime())/(24*60*60*1000))) +1;

    let parameters:any = { 
      section_name: 'Advertisers',
      page_name: 'Categories',
      category:value,
      startDate: this.itemService.startDateTemp,
      days: this.itemService.days,
      endDate: this.itemService.endDateTemp,
    }
    this.itemService.logEvent('onCategoryChange', parameters);

    this.itemService.selected_adv_brand = null;
    this.itemService.selected_adv_channel = null;
    this.itemService.selected_adv = null;
    
    this.itemService.selected_cat = value;
    

    this.itemService.categories();

    // this.itemService.charts_channels();

  }



  ngOnInit() {

      let parameters:any = { section_name: 'Advertisers', page_name: 'Categories'}
      this.itemService.logEvent('onPageView', parameters);
      
    this.itemService.secondary_selected_adv = null;
    this.itemService.secondary_selected_adv_brand = null;
    this.itemService.selected_cat = null;

    this.itemService.selected_adv_brand = null;
    this.itemService.selected_adv_channel = null;
    if(this.itemService.selected_adv) {
      this.itemService.remeberAdv = this.itemService.selected_adv;
      this.itemService.selected_adv = null;
    }
    this.itemService.showSpinner = true;    
    this.itemService.url =this.router.url;    
    if(this.itemService.dataAvailable) {
      // console.log('Categories Block');
      this.itemService.categories();
    this.itemService.showSpinner = false;    
      
    } else {
      // console.log('Date Change Block');  
      this.itemService.dateChangeDetector();
    }
  }

} 


// WEBPACK FOOTER //
// ./src/app/categories/categories.component.ts